// ControlsSection.tsx

import { Dayjs } from "dayjs";
import React from "react";
import styled from "styled-components";
import {gamesheetColours} from "../../colors";

type CalendarControlsProps = {
  leftArrowClick: () => void;
  rightArrowClick: () => void;
  selectedMonth: Dayjs;
};

type ArrowProps = {
  onClick: () => void;
};

const ControlsContainer = styled.div.attrs({ className: "calendar-controls-container" })`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
`;

const LeftArrowIcon = ({ onClick }: ArrowProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="84" height="72" viewBox="0 0 84 72" fill="none" onClick={onClick} style={{ marginLeft: "-15px", cursor: "pointer" }}>
    <path
      d="M30.6283 33.2763L48.0048 15.9008C48.8425 15.063 50.2015 15.063 51.0392 15.9008L53.0662 17.9276C53.903 18.7645 53.9039 20.1199 53.0697 20.9586L39.2982 34.7935L53.0688 48.6294C53.9039 49.4681 53.9021 50.8235 53.0652 51.6603L51.0384 53.6872C50.2006 54.525 48.8416 54.525 48.0038 53.6872L30.6283 36.3108C29.7906 35.473 29.7906 34.1141 30.6283 33.2763Z"
      fill="#FEC307"
    />
  </svg>
);

const RightArrowIcon = ({ onClick }: ArrowProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="90" height="67" viewBox="0 0 90 67" fill="none" onClick={onClick} style={{ marginRight: "-15px", cursor: "pointer" }}>
    <path
      d="M56.066 33.3477L38.6896 49.3048C37.8518 50.0742 36.4928 50.0742 35.6551 49.3048L33.6282 47.4434C32.7913 46.6749 32.7905 45.4301 33.6247 44.6599L47.3961 31.9543L33.6255 19.2479C32.7905 18.4777 32.7922 17.2329 33.6291 16.4644L35.656 14.603C36.4937 13.8336 37.8527 13.8336 38.6905 14.603L56.066 30.5609C56.9038 31.3303 56.9038 32.5783 56.066 33.3477Z"
      fill="#FEC307"
    />
  </svg>
);

const Header = styled.div.attrs({ className: "calendar-header" })`
  color: ${gamesheetColours.secondary[500]};
  text-align: center;
  font-family: Rubik;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
`;

const CalendarControls: React.FC<CalendarControlsProps> = ({ selectedMonth, leftArrowClick, rightArrowClick }) => {
  const formattedMonth = selectedMonth.format("MMMM YYYY");

  return (
    <ControlsContainer>
      <LeftArrowIcon onClick={leftArrowClick} />
      <Header>{formattedMonth}</Header>
      <RightArrowIcon onClick={rightArrowClick} />
    </ControlsContainer>
  );
};

export default CalendarControls;
